export const GET_FULL_LIST = 'GET_FULL_LIST';
